import { Modal, Form, Input, Button, message } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useState } from "react";
import api from "../utils/appApi";

export default function ChangePasswordModal({ visible, onClose, user, onSuccess }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await api.users.changePassword(user.id, {
        new_password: values.new_password,
        confirm_password: values.confirm_password,
      });

      message.success("Parola a fost schimbată cu succes!");
      form.resetFields();
      onClose();
      onSuccess?.();
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "A apărut o eroare la schimbarea parolei";
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`Schimbare parolă - ${user?.name || "Utilizator"}`}
      visible={visible}
      onCancel={onClose}
      footer={null}
      centered
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          label="Parolă nouă"
          name="new_password"
          rules={[
            { required: true, message: "Parola nouă este obligatorie" },
            {
              min: 8,
              message: "Parola trebuie să aibă cel puțin 8 caractere",
            },
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Introduceți parola nouă"
          />
        </Form.Item>

        <Form.Item
          label="Confirmare parolă"
          name="confirm_password"
          dependencies={["new_password"]}
          rules={[
            { required: true, message: "Confirmarea parolei este obligatorie" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Parolele nu corespund"));
              },
            }),
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Confirmați parola nouă"
          />
        </Form.Item>

        <div className="modal-actions">
          <Button key="cancel" onClick={onClose}>
            Anulare
          </Button>
          <Button
            key="submit"
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            Schimbă parola
          </Button>
        </div>
      </Form>
    </Modal>
  );
}